export const en: Record<string, string> = {
  // Comum
  'common.signIn': 'Sign in',
  'common.signOut': 'Log out',
  'common.getStarted': 'Get started',
  'common.createAccount': 'Create an account',
  'common.language': 'Language',
  'common.loading': 'Loading…',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.back': 'Back',

  // Navegação
  'nav.connections': 'Connections',
  'nav.contacts': 'Contacts',
  'nav.inbox': 'Inbox',
  'nav.followUps': "Smart Follow-up",
  'nav.insights': "Customer Insights",
  'nav.chatAnalysis': "AI Chat Analysis",
  'nav.autoReplies': "Auto-replies",
  'ar.title': "Auto-replies",
  'ar.subtitle': "Answer customers automatically: menu, hours, delivery, location, number change…",
  'ar.add': "Add auto-reply",
  'ar.galleryTitle': "Pick a ready template for your restaurant",
  'ar.blank': "Blank reply",
  'ar.blankHelp': "Write your own from scratch",
  'ar.empty': "No auto-replies yet. Start from a ready template and edit it.",
  'ar.pickTemplate': "Choose a template",
  'ar.newTitle': "New auto-reply",
  'ar.editTitle': "Edit auto-reply",
  'ar.name': "Name",
  'ar.trigger': "When does it reply?",
  'ar.trigger.ANY': "Any message the customer sends",
  'ar.trigger.FIRST_MESSAGE': "A new customer's first message",
  'ar.trigger.OUTSIDE_HOURS': "When the restaurant is closed",
  'ar.trigger.KEYWORDS': "When the message contains certain words",
  'ar.when.ANY': "Replies to any message",
  'ar.when.FIRST_MESSAGE': "Replies to a new customer's first message",
  'ar.when.OUTSIDE_HOURS': "Replies when closed (open {from} → {to})",
  'ar.when.KEYWORDS': "Replies when they write: {words}",
  'ar.keywords': "Words that trigger it",
  'ar.keywordsHelp': "Separate with commas. Spelling variants (أ/ا, ة/ه) are matched automatically.",
  'ar.openHours': "Opening hours",
  'ar.openHoursHelp': "In the company's timezone. Hours past midnight work (e.g. 12:00 → 02:00).",
  'ar.message': "The reply",
  'ar.messageHelp': "{{name}} becomes the customer's first name.",
  'ar.fillIn': "Fill in the parts in brackets before turning it on: {parts}",
  'ar.media': "Attachment (optional)",
  'ar.mediaUpload': "Upload image / PDF",
  'ar.mediaReplace': "Replace",
  'ar.mediaRemove': "Remove",
  'ar.mediaHelp': "For the menu: upload its photo or PDF; the reply text goes with it.",
  'ar.numbers': "Numbers",
  'ar.numbersHelp': "Leave all unticked to use it on every number.",
  'ar.notReceiving': "\"Receive messages\" is off",
  'ar.cooldown': "Repeat to the same customer",
  'ar.priority': "Priority",
  'ar.priorityHelp': "Lower goes first; one reply per message.",
  'ar.cooldown.0': "Every time",
  'ar.cooldown.1': "Once an hour",
  'ar.cooldown.6': "Once every 6 hours",
  'ar.cooldown.12': "Once every 12 hours",
  'ar.cooldown.24': "Once a day",
  'ar.cooldown.72': "Once every 3 days",
  'ar.cooldown.168': "Once a week",
  'ar.cooldown.720': "Once a month",
  'ar.enabled': "Turned on",
  'ar.on': "On",
  'ar.off': "Off",
  'ar.turnOn': "Turn on",
  'ar.turnOff': "Turn off",
  'ar.turnedOn': "Turned on",
  'ar.turnedOff': "Turned off",
  'ar.edit': "Edit",
  'ar.delete': "Delete",
  'ar.saved': "Saved",
  'ar.confirmDelete': "Delete the auto-reply \"{title}\"?",
  'ar.allNumbers': "All numbers",
  'ar.sentCount': "sent {n} times",
  'ar.delay': "Wait before replying",
  'ar.delayNone': "Reply right away",
  'ar.delayMinutes': "{n} minutes",
  'ar.delayHelp': "If a team member answers the customer during the wait, the auto-reply is cancelled.",
  'ar.afterMinutes': "after {n} min if nobody answers",
  'ar.catchUpTitle': "Answer customers who were left without a reply",
  'ar.catchUpHelp': "For example after an outage: customers whose last message is theirs since this time get the matching auto-reply, one at a time with a 20–60 second gap.",
  'ar.catchUpSince': "Since:",
  'ar.catchUpCount': "Count them",
  'ar.catchUpStart': "Answer {n} customers",
  'ar.catchUpConfirm': "Send the auto-reply to {n} customers now?",
  'ar.catchUpPreview': "{unanswered} left without a reply: {matched} have an auto-reply that fits, {noRule} have none and will be skipped.",
  'ar.catchUpStatus.RUNNING': "Answering…",
  'ar.catchUpStatus.DONE': "Last run finished",
  'ar.catchUpStatus.STOPPED': "Last run was stopped",
  'ar.catchUpStatus.FAILED': "Stopped after repeated send failures",
  'ar.catchUpCounts': "{sent} answered · {skipped} skipped · {failed} failed",
  'ar.lastError': "Last send failed ({when})",
  'ar.silentNumbers': "Auto-replies only work on numbers with \"Receive messages\" on. Off now on: {numbers} (turn it on from Connections).",
  'ar.rulesNote': "One reply per incoming message. The bot stays quiet when a team member replied in the last 10 minutes, for unsubscribed customers, and for customers inside an interactive campaign.",
  'ca.title': "AI Chat Analysis",
  'ca.subtitle': "The AI reads every customer chat of a period and writes you a report",
  'ca.new': "New analysis",
  'ca.empty': "No analysis yet. Choose a period and the AI will read every chat in it.",
  'ca.newTitle': "Analyse the chats of a period",
  'ca.name': "Name",
  'ca.namePlaceholder': "e.g. Last week",
  'ca.period': "Period",
  'ca.lastDays': "Last {n} days",
  'ca.numbers': "Numbers",
  'ca.numbersHelp': "Leave all unticked to analyse every number.",
  'ca.costNote': "The AI reads each chat once (one request per chat) plus one request for the report; the cost is charged to your AI key. Claude Haiku is the cheapest, Opus the most thorough.",
  'ca.count': "Count the chats",
  'ca.willAnalyse': "{n} chats will be analysed",
  'ca.start': "Start the analysis",
  'ca.started': "The analysis started",
  'ca.chats': "{n} chats",
  'ca.back': "← All analyses",
  'ca.status.RUNNING': "AI reading",
  'ca.status.SUMMARIZING': "Writing the report",
  'ca.status.DONE': "Done",
  'ca.status.FAILED': "Failed",
  'ca.status.CANCELLED': "Stopped",
  'ca.itemStatus.PENDING': "Waiting",
  'ca.itemStatus.WORKING': "Reading",
  'ca.itemStatus.FAILED': "Failed",
  'ca.itemStatus.DONE': "Done",
  'ca.progress': "{done} of {total} chats read · {failed} failed",
  'ca.stop': "Stop",
  'ca.stopped': "Stopped",
  'ca.retryFailed': "Retry {n} failed chats",
  'ca.rewriteReport': "Rewrite the report",
  'ca.delete': "Delete",
  'ca.deleted': "Deleted",
  'ca.confirmDelete': "Delete this analysis?",
  'ca.report': "The AI report",
  'ca.kpi.chats': "Chats",
  'ca.kpi.orders': "Orders",
  'ca.kpi.revenue': "Order value",
  'ca.kpi.avg': "average {n} AED ({k} orders with a price)",
  'ca.kpi.reply': "Median first reply",
  'ca.kpi.slow': "{n} replies took over 30 min",
  'ca.kpi.unanswered': "Never answered",
  'ca.kpi.new': "New customers",
  'ca.kpi.returning': "Returning customers",
  'ca.kpi.chatsToOrders': "chats → orders",
  'ca.kpi.ads': "Chats from ads/posts",
  'ca.min': "{n} min",
  'ca.hours': "{n} h",
  'ca.byNumber': "Results per number (branch)",
  'ca.col.number': "Number",
  'ca.intents': "Why they wrote",
  'ca.sources': "Where they say they heard of you",
  'ca.orderTypes': "Order type",
  'ca.topItems': "Most ordered",
  'ca.askedNotOrdered': "Asked about but not ordered",
  'ca.areas': "Delivery areas",
  'ca.complaints': "Complaints",
  'ca.lostReasons': "Why they did not order",
  'ca.peak': "When customers write (hour of day and weekday)",
  'ca.intent.ORDER': "Order",
  'ca.intent.PRICE_INQUIRY': "Price question",
  'ca.intent.MENU_REQUEST': "Menu request",
  'ca.intent.DELIVERY_QUESTION': "Delivery question",
  'ca.intent.RESERVATION': "Reservation",
  'ca.intent.COMPLAINT': "Complaint",
  'ca.intent.FEEDBACK': "Feedback",
  'ca.intent.OTHER': "Other",
  'ca.orderType.DELIVERY': "Delivery",
  'ca.orderType.PICKUP': "Pickup",
  'ca.orderType.DINE_IN': "Dine-in",
  'ca.orderType.UNKNOWN': "Not stated",
  'ca.source.INSTAGRAM': "Instagram",
  'ca.source.FACEBOOK': "Facebook",
  'ca.source.TIKTOK': "TikTok",
  'ca.source.SNAPCHAT': "Snapchat",
  'ca.source.GOOGLE': "Google",
  'ca.source.DELIVERY_APP': "Delivery app (Talabat…)",
  'ca.source.FRIEND': "A friend",
  'ca.source.RETURNING': "Past customer",
  'ca.source.PASSING_BY': "Passed by",
  'ca.source.NONE': "Not mentioned",
  'ca.source.OTHER': "Other",
  'ca.filter.ALL': "All",
  'ca.filter.ORDERED': "Ordered",
  'ca.filter.NOT_ORDERED': "Did not order",
  'ca.filter.COMPLAINT': "Complaints",
  'ca.filter.UNANSWERED': "Never answered",
  'ca.returning': "returning",
  'ca.orderedTag': "Ordered",
  'ca.replyIn': "First reply: {t}",
  'ci.title': "Customer Insights",
  'ci.subtitle': "Who your customers are and where they came from, read from your WhatsApp chats",
  'ci.refresh': "Refresh",
  'ci.export': "Export (Excel)",
  'ci.empty': "No conversations yet. Turn on \"Receive messages\" on your numbers, or import chats from the Inbox.",
  'ci.dataNote': "{total} customers, from the chats the platform has since {since}. Older chats only count if they were imported in the Inbox.",
  'ci.segmentsTitle': "Where each customer stands",
  'ci.segment.LOYAL': "Loyal",
  'ci.segment.ACTIVE': "Active",
  'ci.segment.NEW': "New",
  'ci.segment.AT_RISK': "At risk",
  'ci.segment.ONE_TIME': "One-time",
  'ci.segment.DORMANT': "Dormant",
  'ci.segmentRule.LOYAL': "wrote on {loyalActiveDays}+ different days in {loyalWindowDays} days, last time within {loyalRecentDays} days",
  'ci.segmentRule.ACTIVE': "wrote in the last {activeDays} days",
  'ci.segmentRule.NEW': "first message within {newDays} days",
  'ci.segmentRule.AT_RISK': "came {atRiskMinDays}+ days before, silent for {activeDays}–{atRiskMaxSilence} days",
  'ci.segmentRule.ONE_TIME': "wrote on a single day, a while ago",
  'ci.segmentRule.DORMANT': "came several times, silent for a long time",
  'ci.originsTitle': "Where they came from",
  'ci.originsHelp': "Click a row to list those customers.",
  'ci.origin.AD': "Sponsored ad",
  'ci.origin.POST': "Facebook/Instagram post",
  'ci.origin.LINK': "WhatsApp link (wa.me)",
  'ci.origin.CAMPAIGN': "Our campaign",
  'ci.origin.OUTREACH': "We wrote first",
  'ci.origin.DIRECT': "Wrote to us by themselves",
  'ci.originHelp.AD': "Clicked a \"Message us on WhatsApp\" ad",
  'ci.originHelp.POST': "Came from a post",
  'ci.originHelp.LINK': "Opened a wa.me link or QR",
  'ci.originHelp.CAMPAIGN': "The first message in the chat was our campaign or follow-up",
  'ci.originHelp.OUTREACH': "We started the chat by hand",
  'ci.originHelp.DIRECT': "They started the chat; WhatsApp gave no ad or link mark",
  'ci.originShort.AD': "Ad",
  'ci.originShort.POST': "Post",
  'ci.originShort.LINK': "Link",
  'ci.originShort.CAMPAIGN': "Campaign",
  'ci.originShort.OUTREACH': "Us",
  'ci.originShort.DIRECT': "Direct",
  'ci.matrixTitle': "Where each group came from",
  'ci.matrixHelp': "Click a number to list those customers.",
  'ci.adsTitle': "Ads and posts that brought customers",
  'ci.adsEmpty': "No customer has come from a marked ad or post yet.",
  'ci.adsNote': "WhatsApp marks the first message that arrives from a \"Message us on WhatsApp\" ad. Chats before this update have no mark, unless imported again from the Inbox.",
  'ci.ad': "Ad / post",
  'ci.adCustomers': "Customers",
  'ci.adActive': "Still active",
  'ci.adLoyal': "Became loyal",
  'ci.adUntitled': "Ad without a title",
  'ci.adOpen': "Open",
  'ci.search': "Search by name, number or ad",
  'ci.showing': "{n} customers",
  'ci.col.customer': "Customer",
  'ci.col.segment': "Group",
  'ci.col.origin': "Came from",
  'ci.col.first': "First message",
  'ci.col.last': "Last message from them",
  'ci.col.days': "Days (90d)",
  'ci.col.messages': "Messages",
  'ci.daysTitle': "Different days they wrote to us (last 90 days in brackets)",
  'ci.daysNote': "\"Days\" counts the different days a customer wrote to you: for a restaurant it is the closest thing to how many times they ordered.",
  'ci.prev': "Previous",
  'ci.next': "Next",
  'fu.title': "Smart Follow-up",
  'fu.subtitle': "Send one AI-written follow-up message to each customer who messaged you",
  'fu.new': "New follow-up",
  'fu.empty': "No follow-ups yet. Create one to reach the customers who messaged you in a period.",
  'fu.open': "Open",
  'fu.delete': "Delete",
  'fu.back': "← All follow-ups",
  'fu.summary': "{total} customers · {sent} done · {replied} replied",
  'fu.newTitle': "New smart follow-up",
  'fu.editTitle': "Follow-up settings",
  'fu.name': "Name",
  'fu.namePlaceholder': "e.g. Weekend offer to last week's customers",
  'fu.mode': "How the AI writes",
  'fu.mode.PERSONALIZED': "Personal message per customer",
  'fu.mode.PERSONALIZED.help': "The AI reads each customer's conversation and writes one message that fits what they asked about.",
  'fu.mode.SHARED': "One message for everyone",
  'fu.mode.SHARED.help': "The AI writes one marketing message; the same message goes to every customer, with their name.",
  'fu.period': "Who to follow up",
  'fu.lastDays': "Last {n} day(s)",
  'fu.periodMode.DAYS_AGO': "Silent for…",
  'fu.periodMode.DATE': "Last wrote on a date",
  'fu.periodMode.RANGE': "Range",
  'fu.daysAgoOption': "{n} days",
  'fu.days': "days",
  'fu.periodExplainDay': "Customers whose last message was on {day} and who have not written since.",
  'fu.periodExplainRange': "Customers whose last message was between {from} and {to}.",
  'fu.errPeriod': "Choose the day or the range",
  'fu.periodHelp': "Taken from the Inbox: connections must have \"Receive messages\" on.",
  'fu.lastWord': "Only chats where the customer sent the last message",
  'fu.lastWordHelp': "Leaves out anyone we already answered after their last message (by hand, campaign or flow).",
  'fu.lastWordShown': "Only chats where the last message is the customer's (no reply from us after it)",
  'fu.periodMode.DATES': "Several dates",
  'fu.daysPickHelp': "Pick a date to add it; pick again to add more.",
  'fu.daysNone': "Add at least one date.",
  'fu.periodExplainDays': "Customers whose last message was on one of these days: {days}, with nothing from them since.",
  'fu.periodShownDays': "Customers whose last message was on one of: {days}, with nothing from them since",
  'fu.periodShownDay': "Customers whose last message was on {day}, with nothing from them since",
  'fu.periodShownRange': "Customers whose last message was between {from} and {to}",
  'fu.lastMessageAt': "Last message: {when} ({ago})",
  'fu.brief': "Brief for the AI",
  'fu.briefPlaceholder': "What you sell, the current offer, prices, delivery areas, the tone you want…",
  'fu.briefHelp': "The AI only uses facts from this brief: it will not invent prices or discounts. Each message opens with a greeting by the customer's name.",
  'fu.greeting': "Greeting (first message)",
  'fu.greetingHelp': "{{name}} becomes the customer's first name. Leave empty to send no greeting.",
  'fu.messageCount': "Marketing messages per customer",
  'fu.maxDelay': "Longest wait between customers",
  'fu.minutes': "{n} min",
  'fu.maxDelayHelp': "Each customer gets one message; the gap before the next customer is random, from 30 seconds up to this.",
  'fu.aiProvider': "AI provider",
  'fu.aiModel': "Model",
  'fu.sendFrom': "Send from",
  'fu.sendFromAuto': "Automatic: the number the customer talked to",
  'fu.sendFromHelp': "All messages go out from this number.",
  'fu.sendFromMetaHelp': "Meta rule: this number can only send to customers who wrote to it in the last 24 hours. Others go out from the number below, or are skipped.",
  'fu.fromNumber': "from {number}",
  'fu.fallback': "Number for customers outside Meta's 24-hour window",
  'fu.fallbackNone': "None: skip those customers",
  'fu.fallbackHelp': "Meta only allows free messages within 24 hours of the customer's last message. Older ones are sent from this number.",
  'fu.working': "Working…",
  'fu.createAndFind': "Create and find customers",
  'fu.saved': "Saved",
  'fu.created': "Follow-up created",
  'fu.listRebuilt': "The customer list was rebuilt",
  'fu.messagesReset': "Settings changed: write the messages again",
  'fu.confirmDelete': "Delete the follow-up \"{title}\"?",
  'fu.deleted': "Deleted",
  'fu.hoursAgo': "{n} h ago",
  'fu.daysAgo': "{n} days ago",
  'fu.status.DRAFT': "Draft",
  'fu.status.GENERATING': "AI writing",
  'fu.status.READY': "Ready to review",
  'fu.status.SENDING': "Sending",
  'fu.status.PAUSED': "Paused",
  'fu.status.DONE': "Done",
  'fu.status.CANCELLED': "Stopped",
  'fu.item.PENDING': "Not written",
  'fu.item.GENERATING': "Writing",
  'fu.item.READY': "Ready",
  'fu.item.QUEUED': "Waiting",
  'fu.item.SENDING': "Sending",
  'fu.item.SENT': "Sent",
  'fu.item.REPLIED': "Replied",
  'fu.item.SKIPPED': "Skipped",
  'fu.item.FAILED': "Failed",
  'fu.upTo': "gaps up to {n} min",
  'fu.counts': "{total} customers · {included} included · {skipped} skipped",
  'fu.progress': "{sent} sent · {replied} replied · {failed} failed · {left} left",
  'fu.writing': "written {done} of {total}",
  'fu.editSettings': "Settings",
  'fu.refreshList': "Refresh list",
  'fu.writingStarted': "The AI is writing the messages",
  'fu.rewriteAll': "Rewrite all",
  'fu.write': "Write with AI",
  'fu.confirmStart': "Start sending to {n} customer(s)?",
  'fu.started': "Sending started",
  'fu.start': "Start sending",
  'fu.pause': "Pause",
  'fu.paused': "Paused",
  'fu.resume': "Resume",
  'fu.resumed': "Sending resumed",
  'fu.confirmStop': "Stop sending? Customers who have not received everything will not get the rest.",
  'fu.stopped': "Stopped",
  'fu.stop': "Stop",
  'fu.sharedTitle': "The message for everyone",
  'fu.ready.hours': "Ready message: open 2 PM – 4 AM",
  'fu.writeMyself': "Write it myself",
  'fu.sharedEmpty': "Pick a ready message, write your own, or press \"Write with AI\". Then save.",
  'fu.saveMessages': "Save message",
  'fu.noCustomers': "No customer's last message falls in this period.",
  'fu.include': "Include",
  'fu.chatOn': "Chat on {number}",
  'fu.sendsFrom': "sends from {number}",
  'fu.byNumber': "Chats found per number:",
  'fu.leaveOut': "Leave out",
  'fu.confirmLeaveOut': "Leave this customer out? They will not receive the message.",
  'fu.editWhileSending': "Save before this customer's turn, or pause first.",
  'fu.writingOne': "The AI is writing…",
  'fu.rewriteOne': "Rewrite",
  'nav.campaigns': 'Campaigns',
  'nav.interactiveCampaign': 'Interactive Campaign',
  'nav.users': 'Users',
  'nav.settings': 'Settings',
  'nav.superAdmin': 'Super Admin',

  // Página de apresentação
  'landing.badge': 'WhatsApp marketing for businesses',
  'landing.title': 'One platform to run',
  'landing.subtitle': 'Targeted campaigns, one shared inbox and a clear report for every campaign — instead of scattered tools and spreadsheets.',
  'landing.ctaTrial': 'Start free — {days} days',
  'landing.menu.features': 'Features',
  'landing.menu.how': 'How it works',
  'landing.menu.plans': 'Pricing',

  'landing.features.title': 'Everything you need to run it properly',
  'landing.features.campaigns.title': 'Campaigns for your segments',
  'landing.features.campaigns.text': 'Pick a segment and send one message with text, an image or a file, at a steady pace that keeps delivery high.',
  'landing.features.inbox.title': 'One shared inbox',
  'landing.features.inbox.text': 'Read the whole conversation, reply with text or files, and see who is still waiting — your team, one place.',
  'landing.features.analytics.title': 'Reports that tell you what worked',
  'landing.features.analytics.text': 'Delivery, read and reply rates per campaign, how fast your team answers, and the list of everyone who engaged.',
  'landing.features.contacts.title': 'A list that keeps itself current',
  'landing.features.contacts.text': 'Import from Excel or CSV, organise by category, export anytime. New numbers that message you are added automatically.',
  'landing.features.optout.title': 'Respect for the customer',
  'landing.features.optout.text': 'Anyone replying STOP is removed immediately, gets a confirmation, and is excluded from future campaigns.',
  'landing.features.privacy.title': 'Each company on its own',
  'landing.features.privacy.text': 'Contacts, campaigns and conversations are fully isolated — only your team sees them.',

  'landing.steps.title': 'From sign-up to first campaign the same day',
  'landing.steps.one.title': 'Create your account',
  'landing.steps.one.text': 'Enter your WhatsApp number and confirm the code you receive. No credit card.',
  'landing.steps.two.title': 'Connect your number',
  'landing.steps.two.text': 'Scan a QR code once, the same way WhatsApp Web works.',
  'landing.steps.three.title': 'Import and send',
  'landing.steps.three.text': 'Upload your contacts, write the message, and watch the replies come in.',

  'landing.plans.title': 'Plans that grow with you',
  'landing.plans.subtitle': 'Start with a {days}-day free trial and subscribe when you are ready. Change your plan anytime.',
  'landing.plans.popular': 'Most popular',
  'landing.plans.messages': '{count} messages per month',
  'landing.plans.contacts': '{count} contacts',
  'landing.plans.numbers': '{count} WhatsApp number(s)',
  'landing.plans.users': '{count} team members',
  'landing.plans.included': 'Inbox and reports included',
  'landing.plans.startFree': 'Start free',
  'landing.titleAccent': 'your WhatsApp marketing',
  'landing.ctaDemo': 'See how it works',
  'landing.note1': 'No credit card',
  'landing.note2': 'Connect your number with a QR scan',
  'landing.note3': 'Nothing to install',
  'landing.menu.faq': 'FAQ',
  'landing.mock.campaign': 'October offers',
  'landing.mock.running': 'Running now',
  'landing.mock.sent': 'Sent',
  'landing.mock.delivered': 'Delivered',
  'landing.mock.read': 'Read',
  'landing.mock.replied': 'Replied',
  'landing.mock.inbox': 'Inbox',
  'landing.mock.msgIn': 'How much is it?',
  'landing.mock.msgOut': 'Sure — sending you the details now 👌',
  'landing.pillars.send.title': 'Send',
  'landing.pillars.send.text': 'One campaign reaches a whole segment, with text, an image or a file.',
  'landing.pillars.reply.title': 'Reply',
  'landing.pillars.reply.text': 'Every answer lands in one inbox, and your team replies without touching a phone.',
  'landing.pillars.measure.title': 'Measure',
  'landing.pillars.measure.text': 'See who received, read and replied — and why any message did not arrive.',
  'landing.features.subtitle': 'Not just a sender — the full loop, from the message to the reply to the decision.',
  'landing.steps.subtitle': 'Three steps, no complicated setup and no waiting for approvals.',
  'landing.policy.title': 'A steady pace, a healthy number',
  'landing.policy.text': 'The platform controls the rhythm instead of dumping messages all at once — better delivery, and a better experience for the person receiving them.',
  'landing.policy.chip1': 'A gap between messages',
  'landing.policy.chip2': 'A daily cap per number',
  'landing.policy.chip3': 'A sending window in your timezone',
  'landing.policy.chip4': 'Automatic stop if failures rise',
  'landing.plans.note': 'Every plan includes the Arabic and English interface, automatic opt-out handling and support on WhatsApp.',
  'landing.faq.title': 'Frequently asked questions',
  'landing.faq.q1': 'Do I need to install anything?',
  'landing.faq.a1': 'No. It runs in the browser, and your number connects with a single QR scan — exactly like WhatsApp Web.',
  'landing.faq.q2': 'Can I use my existing number?',
  'landing.faq.a2': 'Yes, the same number your customers already know. Replies keep arriving on your phone and in the platform at the same time.',
  'landing.faq.q3': 'How do you keep delivery healthy?',
  'landing.faq.a3': 'Messages leave at a steady pace rather than all at once, with a gap between them, a daily cap and a sending window, and an automatic stop if failures rise. Anyone asking to stop is excluded immediately.',
  'landing.faq.q4': 'Where do replies go?',
  'landing.faq.a4': 'Into one shared inbox: the full conversation, who is still waiting, and you can answer with text or files without leaving the screen.',
  'landing.faq.q5': 'Can I see how a campaign performed?',
  'landing.faq.a5': 'Yes. Every campaign has a report with delivery, read and reply rates, the reasons messages did not arrive, and the list of everyone who engaged — downloadable as Excel.',
  'landing.faq.q6': 'Can I cancel anytime?',
  'landing.faq.a6': 'Yes. The trial is completely free with no credit card, and you can stop or change your plan whenever you want.',
  'landing.cta.title': 'Try it on a single campaign and compare the result',
  'landing.cta.text': 'Minutes to set up, and your first campaign can go out today. No commitment.',
  'landing.footer.tagline': 'WhatsApp marketing for businesses — sending, replies and reports in one place.',


  // Entrar
  'login.welcome': 'Welcome!',
  'login.subtitle': 'Log in to access your account',
  'login.identifier': 'Email or WhatsApp number',
  'login.identifierPlaceholder': 'you@email.com or +971...',
  'login.password': 'Password',
  'login.submit': 'Log in',
  'login.submitting': 'Logging in...',
  'login.newHere': 'New here?',
  'login.invalidIdentifier': 'Enter your email or WhatsApp number',
  'login.passwordMin': 'Password must be at least 6 characters',

  // Cadastro
  'signup.title': 'Create your account',
  'signup.trialSubtitle': 'Start with a {days}-day free trial',
  'signup.closed': 'Sign-up is currently closed',
  'signup.closedText': 'New accounts are not open right now. Please contact us to get access.',
  'signup.goSignIn': 'Go to sign in',
  'signup.phone': 'WhatsApp number',
  'signup.phoneHelp': 'Include the country code. We send a verification code to this number on WhatsApp.',
  'signup.sendCode': 'Send code',
  'signup.sending': 'Sending…',
  'signup.codeSent': 'We sent a code to your WhatsApp',
  'signup.change': 'change',
  'signup.code': 'Verification code',
  'signup.resendIn': 'Resend in {seconds}s',
  'signup.resend': 'Send a new code',
  'signup.name': 'Your name',
  'signup.company': 'Company name',
  'signup.password': 'Password',
  'signup.passwordPlaceholder': 'At least 8 characters',
  'signup.passwordHelp': 'You will sign in with your WhatsApp number and this password.',
  'signup.create': 'Create account',
  'signup.creating': 'Creating…',
  'signup.created': 'Account created. Welcome!',
  'signup.haveAccount': 'Already have an account?',
  'signup.errorSend': 'Could not send the code',
  'signup.errorCreate': 'Could not create the account',

  // Connections
  'conn.title': "WhatsApp Connections",
  'conn.loading': "Loading connections...",
  'conn.refresh': "Refresh",
  'conn.activeSessions': "Active Sessions",
  'conn.empty': "No WhatsApp sessions found. Create a new session to get started.",
  'conn.connectedAs': "Connected as:",
  'conn.receiving': "Receiving messages — replies appear in the Inbox",
  'conn.notReceiving': "Not receiving messages: replies from this number are lost",
  'conn.connect': "Connect",
  'conn.viewQr': "View QR Code",
  'conn.restart': "Restart",
  'conn.remove': "Remove",
  'conn.newSession': "New WhatsApp Session",
  'conn.newSessionSubtitle': "Enter a name to identify this session",
  'conn.provider': "WhatsApp Provider *",
  'conn.providerHelp': "Choose the provider to connect to WhatsApp",
  'conn.sessionName': "Session Name *",
  'conn.sessionNamePlaceholder': "E.g. sales, support, service",
  'conn.sessionNameHelp': "Use a descriptive name to make it easy to identify",
  'conn.interactive': "Interactive Campaign",
  'conn.interactiveHelp': "Enables receiving messages for automated conversational flows",
  'conn.create': "Create Session",
  'conn.creating': "Creating...",
  'conn.qrTitle': "Scan the QR Code with your WhatsApp",
  'conn.qrStep1': "Open WhatsApp on your phone, go to",
  'conn.qrStep2': "Settings → Linked devices → Link a device",
  'conn.qrGenerating': "Generating QR Code...",
  'conn.qrWait': "Please wait a moment",
  'conn.qrRefresh': "Refresh QR",
  'conn.qrExpired': "QR Code expired",
  'conn.close': "Close",
  'conn.statusConnected': "Connected",
  'conn.statusWaitingQr': "Waiting for QR Code",
  'conn.requesting': "Requesting...",
  'conn.stopReceivingTitle': "Stop receiving messages from this number",
  'conn.receiveTitle': "Receive replies from this number in the Inbox",
  'conn.saving': "Saving...",
  'conn.stopReceiving': "Stop receiving",
  'conn.receiveMessages': "Receive messages",
  'conn.errLoad': "Failed to load WhatsApp sessions",
  'conn.errName': "Enter a name for the session",
  'conn.errWaha': "Configure the WAHA credentials in the system settings",
  'conn.errEvolution': "Configure the Evolution API credentials in the system settings",
  'conn.errQuepasa': "Configure the Quepasa credentials in the system settings",
  'conn.metaName': "WhatsApp Cloud API (Meta)",
  'conn.metaIntro': "Official Meta API, no QR code. Copy these values from your app on Meta for Developers → WhatsApp → API Setup.",
  'conn.metaPhoneId': "Phone Number ID",
  'conn.metaWabaId': "WhatsApp Business Account ID",
  'conn.metaToken': "Permanent access token (System User)",
  'conn.metaTokenHelp': "Create it in Business Settings → System users, with the whatsapp_business_messaging and whatsapp_business_management permissions.",
  'conn.metaAppSecret': "App Secret",
  'conn.metaAppSecretHelp': "App settings → Basic. Used to confirm that incoming messages really come from Meta.",
  'conn.metaTemplateNote': "People who have not messaged you in the last 24 hours can only receive approved templates. Template campaigns are coming next.",
  'conn.errMetaFields': "Fill in the four Meta fields",
  'conn.metaWebhookTitle': "Last step: set the webhook in Meta",
  'conn.metaWebhookSteps': "In your app on Meta for Developers, open WhatsApp → Configuration → Webhook → Edit, paste these two values, then subscribe to the \"messages\" field.",
  'conn.metaCallbackUrl': "Callback URL",
  'conn.metaVerifyToken': "Verify token",
  'conn.metaNoPublicUrl': "The platform has no public address yet (APP_URL). Set it, then open this window again from the Webhook button.",
  'conn.metaWebhookButton': "Webhook",
  'conn.metaQuality': "Number quality",
  'conn.metaCheck': "Check connection",
  'conn.metaChecked': "Connection confirmed with Meta",
  'conn.copy': "Copy",
  'conn.copied': "Copied",
  'conn.done': "Done",
  'conn.removed': "Session removed successfully",
  'conn.restarted': "Session restarted",
  'conn.qrRequested': "QR Code requested. Please wait...",
  'conn.qrUnavailable': "QR Code not available",
  'conn.errQrFetch': "Failed to fetch QR Code",
  'conn.errUnknown': "Unknown error",
  'conn.errQuota': "Connection limit reached. Upgrade your plan to continue.",
  'conn.errCreate': "Failed to create session",
  'conn.errRemove': "Failed to remove session",
  'conn.errRestart': "Failed to restart session",
  'conn.inboxOn': "Message receiving enabled",
  'conn.inboxOff': "Message receiving disabled",
  'conn.errInbox': "Failed to update message receiving",
  'conn.errQrRequest': "Failed to request QR Code",
  'conn.statusStopped': "Stopped",
  'conn.statusError': "Error",
  'conn.connectedAsName': "Connected as: {name}",

  // Inbox & contacts
  'inbox.title': "Inbox",
  'inbox.subtitle': "Messages received from your WhatsApp numbers",
  'inbox.empty': "No conversations yet.",
  'inbox.emptyHint': "Turn on message receiving for a connection on the Connections page.",
  'inbox.you': "You:",
  'inbox.loadMore': "Load more",
  'inbox.selectConversation': "Select a conversation to read the messages",
  'inbox.unsubscribed': "Unsubscribed",
  'inbox.readOnly': "Read only",
  'inbox.notInContacts': "Not in contacts",
  'inbox.noPhone': "No phone number",
  'inbox.readOnlyHint': "This older chat has no phone number saved by WhatsApp, so it can only be read.",
  'inbox.uploading': "Uploading the file…",
  'inbox.search': "Search by name, number or message",
  'inbox.attach': "Attach a file",
  'inbox.quickReplies': "Ready messages (auto-replies)",
  'inbox.quickSearch': "Search ready messages…",
  'inbox.quickEmpty': "No ready messages yet. Add them on the Auto-replies page.",
  'inbox.quickRemoveMedia': "Remove",
  'inbox.quickFillIn': "Fill in the parts in brackets before sending.",
  'inbox.reply': "Write a reply…",
  'inbox.send': "Send",
  'inbox.sending': "Sending…",
  'inbox.filterReplies': "Replies",
  'inbox.filterUnread': "Unread",
  'inbox.filterAll': "All",
  'inbox.srcCampaign': "Campaign",
  'inbox.srcFlow': "Interactive campaign",
  'inbox.srcAuto': "Automatic",
  'inbox.today': "Today",
  'inbox.yesterday': "Yesterday",
  'inbox.waContact': "WhatsApp contact",
  'inbox.conversationsCount': "{shown} of {total} conversations",
  'inbox.import': "Import history",
  'inbox.importing': "Importing {done}/{total}…",
  'inbox.importingShort': "Importing…",
  'inbox.imported': "{messages} messages in {conversations} conversations",
  'inbox.importTitle': "Bring the conversation history already stored by the provider into the Inbox",
  'inbox.loadMedia': "Load {type}",
  'inbox.errConversations': "Failed to load conversations",
  'inbox.errMessages': "Failed to load messages",
  'inbox.errFile': "Failed to load the file",
  'inbox.errImport': "Import failed",
  'inbox.errImportStart': "Failed to start the import",
  'inbox.errSend': "Failed to send the message",
  'inbox.errUpload': "Failed to upload the file",
  'inbox.errAttachment': "Failed to send the attachment",
  'contacts.title': "Contacts",
  'contacts.error': "Error",
  'contacts.tryAgain': "Try again",
  'contacts.cancelSelection': "Cancel Selection",
  'contacts.categories': "Categories",
  'contacts.importCsv': "Import CSV",
  'contacts.exportExcel': "Export to Excel",
  'contacts.exporting': "Exporting...",
  'contacts.exported': "Contacts exported successfully",
  'contacts.errExport': "Failed to export contacts",
  'contacts.selectAll': "Select all",
  'contacts.deselectAll': "Deselect all",
  'contacts.loading': "Loading...",
  'contacts.empty': "No contacts found.",
  'contacts.colName': "Name",
  'contacts.colPhone': "Phone",
  'contacts.colEmail': "Email",
  'contacts.colCategory': "Category",
  'contacts.colUpdated': "Updated at",
  'contacts.colActions': "Actions",
  'contacts.sourceWhatsApp': "WhatsApp",
  'contacts.sourceWhatsAppTitle': "Added automatically when this number sent its first WhatsApp message",
  'contacts.unsubscribed': "Unsubscribed",
  'contacts.edit': "Edit",
  'contacts.delete': "Delete",
  'contacts.confirm': "Confirm?",
  'media.image': "📷 Image",
  'media.video': "🎥 Video",
  'media.audio': "🎧 Audio",
  'media.document': "📄 Document",
  'media.sticker': "🩵 Sticker",
  'media.location': "📍 Location",

  // Analytics & plans
  'an.title': "Campaign Analytics",
  'an.window': "Replies counted within",
  'an.days': "{count} days",
  'an.day': "1 day",
  'an.sync': "Sync delivery status",
  'an.syncing': "Syncing…",
  'an.syncNow': "Sync now",
  'an.syncTitle': "Fetch delivered/read confirmations from WhatsApp for messages already sent",
  'an.syncMissing': "Delivered/read status is missing for {count} sent message(s). Sync once to fill it in; new messages update automatically.",
  'an.synced': "Delivery status updated for {count} message(s)",
  'an.loading': "Loading analytics…",
  'an.errLoad': "Failed to load analytics",
  'an.errSync': "Failed to sync delivery status",
  'an.kpiSent': "Sent",
  'an.kpiPending': "{count} still pending",
  'an.kpiDelivered': "Delivered",
  'an.kpiDeliveredSub': "{sent} of {total} sent",
  'an.kpiRead': "Read",
  'an.kpiReadSub': "{count} of delivered (minimum*)",
  'an.kpiReplied': "Replied",
  'an.kpiRepliedSub': "{people} people · {human} likely human",
  'an.kpiUnsub': "Unsubscribed",
  'an.kpiUnsubSub': "{rate}% of sent",
  'an.kpiFailed': "Failed",
  'an.kpiFailedSub': "{rate}% of attempts",
  'an.funnel': "Engagement funnel",
  'an.funnelHuman': "Replied (likely human)",
  'an.timing': "Time to first reply",
  'an.median': "Median:",
  'an.under5m': "Under 5 minutes",
  'an.under1h': "5 – 60 minutes",
  'an.under24h': "1 – 24 hours",
  'an.over24h': "More than a day",
  'an.autoNote': "{count} reply(ies) arrived within 20 seconds — usually WhatsApp Business away/greeting messages.",
  'an.failures': "Why messages failed",
  'an.noFailures': "No failures 🎉",
  'an.perDay': "Replies per day",
  'an.variations': "Reply rate by message variation",
  'an.variation': "Variation",
  'an.rate': "Rate",
  'an.whoReplied': "Who replied",
  'an.hideAuto': "Hide likely automatic",
  'an.searchReplies': "Search name, number or reply",
  'an.exportCsv': "Export CSV",
  'an.noReplies': "No replies in this period yet.",
  'an.colContact': "Contact",
  'an.colAfter': "Replied after",
  'an.colFirst': "First reply",
  'an.colReplies': "Replies",
  'an.openChat': "Open chat →",
  'an.auto': "auto?",
  'an.footnote': "* People who turned off read receipts in WhatsApp show as delivered, so the read rate is a minimum. A reply is any message received from the same number after the campaign message, within the selected period. Older chats that WhatsApp saved without a phone number cannot be matched to a contact.",
  'plan.title': "Plan & billing",
  'plan.usedThisMonth': "Used this month",
  'plan.messagesOf': "{used} / {limit} messages",
  'plan.unlimited': "unlimited",
  'plan.plan': "Plan",
  'plan.status': "Status",
  'plan.statusTrial': "Trial",
  'plan.statusActive': "Active (paid)",
  'plan.statusSuspended': "Suspended (cannot send)",
  'plan.paidUntil': "Paid until",
  'plan.addMonth': "+1 month",
  'plan.paidUntilHelp': "Sending stops after this date until you renew it.",
  'plan.updated': "Plan updated",
  'plan.errUpdate': "Failed to update the plan",
  'plan.perMonth': "{count} messages/month",
  'plan.unlimitedMessages': "Unlimited messages",
  'plan.summary': "{contacts} contacts · {connections} connection(s) · {users} user(s)",
  'plan.saving': "Saving…",
  'sub.ends': "Your {plan} ends in {days} day(s).",
  'sub.left': "Only {left} message(s) left this month on your {plan}.",
  'sub.usage': "{used} / {limit} messages this month",
  'sub.planTrial': "Free trial",
  'sub.planStarter': "Starter",
  'sub.planPro': "Pro",
  'sub.planBusiness': "Business",
  'sub.planInternal': "Internal (no limits)",

  // Campaigns
  'camp.title': "Campaigns",
  'camp.loading': "Loading campaigns...",
  'camp.created': "Created Campaigns",
  'camp.contacts': "Contacts:",
  'camp.sent': "Sent:",
  'camp.sessions': "Sessions:",
  'camp.new': "New Campaign",
  'camp.edit': "Edit Campaign",
  'camp.duplicate': "Duplicate campaign",
  'camp.duplicateTitle': "Duplicate campaign",
  'camp.duplicateSub': "Copied from \"{name}\". Change anything you want, then create it; the original stays as it is.",
  'camp.copySuffix': "(copy)",
  'camp.newSubtitle': "Set up your WhatsApp messaging campaign",
  'camp.editSubtitle': "Changes apply to the messages that have not been sent yet",
  'camp.basicInfo': "Basic Information",
  'camp.basicInfoSub': "Set up the core details of your campaign",
  'camp.name': "Campaign Name *",
  'camp.namePlaceholder': "E.g. Black Friday Promotion 2024",
  'camp.categories': "Contact Categories *",
  'camp.categoriesHelp': "Select which contact categories will receive the campaign",
  'camp.categoriesLocked': "Recipients were defined when the campaign was created and cannot be changed",
  'camp.noCategories': "No categories available",
  'camp.categoriesSelected': "{count} category(ies) selected",
  'camp.connections': "WhatsApp Connections *",
  'camp.multiSession': "Multi-Session with Failover",
  'camp.multiSessionHelp': "Smart system that distributes sending across multiple connections with automatic redundancy.",
  'camp.noConnections': "No WhatsApp connections available",
  'camp.active': "Active",
  'camp.connectionsSelected': "{count} connection(s) selected",
  'camp.randomDelay': "Randomization Time (seconds)",
  'camp.randomDelayHelp': "Additional random interval between sends (0-{max}s), added to the minimum interval from the sending policy",
  'camp.whenToSend': "When to Send",
  'camp.sendNow': "The campaign will run as soon as it is created",
  'camp.scheduleFor': "Schedule for:",
  'camp.scheduleHelp': "Choose a specific date and time",
  'camp.messages': "Campaign Messages",
  'camp.messagesSub': "Set up the content that will be sent to contacts",
  'camp.variablesHint': "Personalize your messages with:",
  'camp.addMessages': "Add one or more messages to be sent in sequence",
  'camp.message': "Message",
  'camp.remove': "Remove",
  'camp.useVariations': "Use text variations",
  'camp.variations': "Text variations",
  'camp.newVariation': "New variation",
  'camp.removeVariation': "Remove variation",
  'camp.availableVars': "Available variables:",
  'camp.variables': "Variables:",
  'camp.file': "File",
  'camp.useVariationsShort': "Use Variations",
  'camp.uploading': "Uploading",
  'camp.upload': "Upload",
  'camp.uploadingFile': "Uploading file...",
  'camp.clickUpload': "Click to upload a file",
  'camp.view': "View",
  'camp.removeFile': "Remove file",
  'camp.fileName': "File name (optional)",
  'camp.caption': "Caption...",
  'camp.waitTime': "Wait Time",
  'camp.waitHelp': "Waits for a while before sending the next message",
  'camp.waitMin': "Minimum: 1 second",
  'camp.waitMax': "Maximum: 3600 seconds (1 hour)",
  'camp.noMessages': "No messages in the sequence",
  'camp.noMessagesHint': "Click \"+ Message\" to start building your campaign.",
  'camp.create': "Create Campaign",
  'camp.saveChanges': "Save Changes",
  'camp.model': "Model *",
  'camp.suggestedModels': "Suggested models:",
  'camp.systemPrompt': "System Prompt *",
  'camp.systemPromptHelp': "Defines how the AI should behave and respond",
  'camp.userPrompt': "User Prompt *",
  'camp.openaiModel': "Enter the OpenAI model (e.g. gpt-3.5-turbo)",
  'camp.groqModel': "Enter the Groq model (e.g. llama-3.1-8b-instant)",
  'camp.report': "Campaign Report",
  'camp.reportLoading': "Loading report...",
  'camp.refreshReport': "Refresh report",
  'camp.status': "Status:",
  'camp.createdBy': "Created by:",
  'camp.createdOn': "Created On:",
  'camp.startedOn': "Started On:",
  'camp.completedOn': "Completed On:",
  'camp.stats': "Sending Statistics",
  'camp.totalContacts': "Total Contacts",
  'camp.messagesSent': "Messages Sent",
  'camp.messagesFailed': "Messages Failed",
  'camp.messagesPending': "Messages Pending",
  'camp.messagesSkipped': "Messages Skipped",
  'camp.bySession': "Distribution by Session",
  'camp.session': "Session",
  'camp.total': "Total",
  'camp.colSent': "Sent",
  'camp.colFailed': "Failed",
  'camp.colSkipped': "Skipped",
  'camp.details': "Message Details",
  'camp.colName': "Name",
  'camp.colPhone': "Phone",
  'camp.colStatus': "Status",
  'camp.colSentAt': "Sent At",
  'camp.colError': "Error",
  'camp.errorDetails': "Error Details:",
  'camp.noMessagesFound': "No messages found",
  'camp.previous': "Previous",
  'camp.next': "Next",
  'camp.analyticsTitle': "Campaign analytics: delivered, read, replies",
  'camp.reportTitle': "View campaign report",
  'camp.pauseTitle': "Pause campaign",
  'camp.resumeTitle': "Resume campaign",
  'camp.editTitle': "Edit campaign",
  'camp.deleteTitle': "Delete campaign",
  'camp.errLoad': "Failed to load campaigns",
  'camp.errCategory': "Select at least one contact category",
  'camp.errConnection': "Select at least one WhatsApp connection",
  'camp.errMessage': "Add at least one message to the campaign",
  'camp.claudeHelp': "Claude writes a personalized message for each contact from your prompt. Needs a Claude API key in Settings → AI.",
  'camp.templateOption': "WhatsApp template (Cloud API)",
  'camp.templateNeedsMeta': "Select a WhatsApp Cloud API connection first: templates come from its WhatsApp Business account.",
  'camp.templateChoose': "Choose an approved template",
  'camp.templateNone': "No approved templates yet",
  'camp.templatePending': "{n} more template(s) are not approved yet (pending or rejected)",
  'camp.templateMissing': "The template \"{name}\" is no longer approved on this account",
  'camp.templateHeaderMedia': "Header {type} link",
  'camp.templateParams': "Template values (you can use {{name}}, {{phone}}...)",
  'camp.templateParamPlaceholder': "e.g. {{name}}",
  'camp.errTemplate': "Choose the WhatsApp template for every template message",
  'camp.errTemplateMedia': "This template has a header image, video or file: upload it before saving",
  'camp.templateCoupon': "Coupon code (copy-code button)",
  'camp.templateUrlSuffix': "End of the link for the \"{button}\" button",
  'camp.errTemplateCoupon': "This template has a copy-code button: enter the coupon code",
  'camp.templateUpload': "Upload",
  'camp.templateUploading': "Uploading…",
  'camp.templateUploadFailed': "The file could not be uploaded",
  'camp.templateHeaderRequired': "Required: this template shows this file above the message",
  'camp.okCreated': "Campaign created successfully!",
  'camp.okUpdated': "Campaign updated",
  'camp.errCreate': "Failed to create campaign",
  'camp.errUpdate': "Failed to update campaign",
  'camp.okFile': "File uploaded successfully!",
  'camp.okFileRemoved': "File removed",
  'camp.errStatus': "Failed to change campaign status",
  'camp.okDeleted': "Campaign deleted successfully!",
  'camp.errDelete': "Failed to delete campaign",
  'camp.okReport': "Report downloaded successfully!",
  'camp.errReport': "Failed to download report",
  'camp.errReportLoad': "Failed to load report",
  'camp.connectionsHeader': "WhatsApp Connections * ({count} selected)",
  'camp.addMessageBtn': "+ Message",
  'fail.notOnWhatsApp': "Number is not on WhatsApp",
  'fail.media': "Media file could not be downloaded",
  'fail.credentials': "Provider rejected the credentials",
  'fail.timeout': "Connection timeout",
  'fail.unsubscribed': "Contact unsubscribed",
  'fail.unknown': "Unknown error",
  'fail.system': "System error — the message was not attempted",

  // Users, import & contact form
  'users.title': "Users",
  'users.search': "Search users...",
  'users.okCreated': "User created successfully!",
  'users.okUpdated': "User updated successfully!",
  'users.errUpdate': "Failed to update user",
  'users.okDeleted': "User deleted successfully!",
  'users.errDelete': "Failed to delete user",
  'csv.title': "Import Contacts via CSV",
  'csv.subtitle': "Import multiple contacts at once",
  'csv.template': "Template CSV",
  'csv.templateHelp': "Download the template with the correct format",
  'csv.download': "Download",
  'csv.select': "Select CSV file",
  'csv.clickSelect': "Click to select",
  'csv.format': "Format: .csv",
  'csv.total': "Total",
  'csv.succeeded': "Succeeded",
  'csv.errors': "Errors",
  'csv.importing': "Importing...",
  'csv.import': "Import",
  'csv.errFile': "Please select a valid CSV file",
  'csv.errNoFile': "Select a CSV file",
  'csv.okTemplate': "Template downloaded successfully!",
  'csv.errTemplate': "Failed to download CSV template",
  'form.name': "Name *",
  'form.namePlaceholder': "Enter the full name",
  'form.phone': "Phone *",
  'form.email': "Email",
  'form.emailPlaceholder': "Enter the email",
  'form.category': "Category",
  'form.selectCategory': "Select a category",
  'form.loadingCategories': "Loading categories...",
  'form.notes': "Notes",
  'form.notesPlaceholder': "Enter additional notes",
  'form.consent': "Consent to receive messages",
  'form.optedOut': "Unsubscribed (does not receive campaigns)",
  'form.perfexId': "Perfex CRM Lead ID",
  'form.perfexHelp': "This contact was imported from Perfex CRM",
  'form.saving': "Saving...",
  'form.okUpdated': "Contact updated successfully",
  'form.okCreated': "Contact created successfully",

  // Settings & users
  'users.empty': "No users found",
  'users.colName': "Name",
  'users.colEmail': "E-mail",
  'users.colRole': "Role",
  'users.colStatus': "Status",
  'users.colLastLogin': "Last Login",
  'users.colActions': "Actions",
  'users.edit': "Edit",
  'users.delete': "Delete",
  'users.formName': "Name",
  'users.formEmail': "Email",
  'users.currentPassword': "Current Password (required to change your password)",
  'users.role': "Role",
  'users.roleUser': "User",
  'users.roleAdmin': "Administrator",
  'users.activeUser': "Active user",
  'set.title': "Settings",
  'set.subtitle': "Configure the system settings",
  'set.loading': "Loading settings...",
  'set.configure': "Configure",
  'set.remove': "Remove",
  'set.openaiDesc': "ChatGPT, GPT-4",
  'set.groqDesc': "LLaMA, Mixtral (ultra-fast)",
  'set.chatwootDesc': "Customer service platform",
  'set.chatwootHelp': "Configure the Chatwoot integration to sync conversations",
  'set.perfexDesc': "Customer and project management system",
  'set.signupTitle': "Customer sign-up",
  'set.signupHelp': "When enabled, anyone can create an account from the sign-up page. They verify their number with a code sent from the connection you choose below, and start on a free trial. You upgrade paying customers from the Super Admin panel.",
  'set.signupAllow': "Allow new customers to sign up",
  'set.signupConnection': "Connection that sends the code",
  'set.signupConnectionHelp': "Use a number of yours, not a customer's. It must stay connected.",
  'set.signupSelect': "— Select a connection —",
  'set.trialDays': "Free trial (days)",
  'set.signupSave': "Save sign-up settings",
  'set.signupSaved': "Sign-up settings saved",
  'set.signupErrConnection': "Choose the WhatsApp connection that sends the verification code",
  'set.policyTitle': "Responsible sending policy",
  'set.policyHelp': "These limits help you send responsibly. They do not prevent blocks if recipients do not want to receive messages — only send to contacts who have agreed.",
  'set.minInterval': "Minimum interval between messages (s)",
  'set.dailyLimit': "Daily limit per number",
  'set.windowStart': "Sending window — start",
  'set.windowEnd': "Sending window — end",
  'set.windowHelp': "If the start is after the end, the window spans midnight",
  'set.timezone': "Time zone",
  'set.timezoneHelp': "IANA time zone used for the sending window",
  'set.autoPause': "Auto-pause at failure rate (%)",
  'set.requireConsent': "Require consent",
  'set.requireConsentHelp': "Only contacts with recorded consent receive campaigns",
  'set.optOutKeywords': "Unsubscribe keywords",
  'set.optOutMessage': "Unsubscribe confirmation message",
  'set.optOutPlaceholder': "Leave blank to use the system default message",
  'set.policySave': "Save sending policy",
  'set.policySaved': "Sending policy saved successfully",
  'set.policyErrSave': "Failed to save sending policy",
  'set.errInterval': "The minimum interval must be between 5 and 3600 seconds",
  'set.errDaily': "The daily limit must be between 1 and 10000",
  'set.errFailure': "The failure rate must be between 5 and 100%",
  'set.errWindow': "Enter the start and end of the sending window",
  'set.openaiKey': "OpenAI API Key",
  'set.openaiKeyHelp': "API key for ChatGPT integration in campaigns",
  'set.groqKey': "Groq API Key",
  'set.claudeDesc': "Claude by Anthropic (excellent Arabic and marketing writing)",
  'set.claudeKey': "Claude API Key",
  'set.claudeHelp': "Create it at console.anthropic.com → API Keys. Used by Smart Follow-up.",
  'set.chatwootUrl': "Chatwoot URL *",
  'set.chatwootUrlHelp': "Full URL of your Chatwoot instance",
  'set.accountId': "Account ID *",
  'set.accountIdHelp': "Numeric ID of your Chatwoot account",
  'set.apiToken': "API Token *",
  'set.errLoad': "Failed to load settings",
  'set.okIntegration': "Integration settings saved successfully",
  'set.errIntegration': "Failed to save integration settings",
  'set.errRemoveIntegration': "Failed to remove integration",
  'set.okPerfex': "Perfex CRM integration configured successfully",
  'set.errPerfex': "Failed to configure Perfex CRM",
  'set.savePolicy': "Save policy",

  // My company
  'company.title': "My Company",
  'company.subtitle': "Your plan, usage and team",
  'company.plan': "Plan",
  'company.status': "Status",
  'company.statusTrial': "Free trial",
  'company.statusActive': "Active",
  'company.statusSuspended': "Suspended",
  'company.renews': "Valid until",
  'company.noExpiry': "No expiry date",
  'company.daysLeft': "{days} day(s) left",
  'company.expired': "Expired",
  'company.ownerPhone': "Account number",
  'company.since': "Customer since",
  'company.usage': "Usage",
  'company.messagesMonth': "Messages this month",
  'company.contacts': "Contacts",
  'company.campaigns': "Campaigns",
  'company.connections': "WhatsApp numbers",
  'company.users': "Team members",
  'company.unlimited': "Unlimited",
  'company.ofLimit': "{used} of {limit}",
  'company.team': "Team",
  'company.manageUsers': "Manage users",
  'company.roleAdmin': "Administrator",
  'company.roleUser': "Member",
  'company.roleSuper': "Platform owner",
  'company.activeUser': "Active",
  'company.inactiveUser': "Inactive",
  'company.lastLogin': "Last login",
  'company.never': "Never",
  'company.blocked': "Sending is paused: {reason}",
  'company.upgradeHint': "Contact us to upgrade your plan.",
  'company.errLoad': "Failed to load the company data",
  'company.platformOwner': "You are signed in as the platform owner. Pick a company to see its data.",
  'nav.company': "My Company",
  'login.tagline': "Campaign Management System",
  'set.policyReadOnly': "These limits are set by the platform to protect your number. They apply to your account and cannot be changed here.",

  // Dashboard
  'nav.dashboard': "Dashboard",
  'dash.title': "Dashboard",
  'dash.subtitle': "How your campaigns and conversations are doing",
  'dash.period7': "Last 7 days",
  'dash.period30': "Last 30 days",
  'dash.period90': "Last 90 days",
  'dash.vsPrevious': "vs previous period",
  'dash.noBaseline': "no earlier data",
  'dash.sent': "Messages sent",
  'dash.delivery': "Delivery rate",
  'dash.deliverySub': "{delivered} of {sent} delivered",
  'dash.read': "Read rate",
  'dash.readSub': "{read} of delivered were read",
  'dash.reply': "Reply rate",
  'dash.replySub': "{people} replied · {human} likely human",
  'dash.newContacts': "New contacts",
  'dash.newContactsSub': "{total} contacts in total",
  'dash.unsubscribed': "Unsubscribed",
  'dash.unsubscribedSub': "{rate}% of messages sent",
  'dash.failed': "Failed",
  'dash.activity': "Daily activity",
  'dash.legendSent': "Sent",
  'dash.legendDelivered': "Delivered",
  'dash.legendReplies': "Replies",
  'dash.noActivity': "No activity in this period",
  'dash.inbox': "Inbox",
  'dash.unread': "Unread messages",
  'dash.awaiting': "Waiting for your reply",
  'dash.responseTime': "Median reply time",
  'dash.answered': "{count} incoming messages answered",
  'dash.openInbox': "Open inbox",
  'dash.numbers': "WhatsApp numbers",
  'dash.sentToday': "{count} sent today",
  'dash.receiving': "receiving",
  'dash.notReceiving': "not receiving",
  'dash.campaigns': "Campaigns in this period",
  'dash.colCampaign': "Campaign",
  'dash.colSent': "Sent",
  'dash.colDelivery': "Delivery",
  'dash.colRead': "Read",
  'dash.colFailed': "Failed",
  'dash.viewAnalytics': "Details",
  'dash.noCampaigns': "No campaigns ran in this period",
  'dash.errLoad': "Failed to load the dashboard",
  'dash.ownerNote': "You are signed in as the platform owner. Open the Super Admin panel to see the companies.",
  'dash.minutes': "{count} min",
  'dash.hours': "{count} h",
  'dash.seconds': "{count} s",

  // Campaign report
  'rep.title': "Campaign report",
  'rep.refresh': "Refresh",
  'rep.export': "Download Excel",
  'rep.analytics': "Open analytics",
  'rep.progress': "Progress",
  'rep.progressOf': "{done} of {total} processed",
  'rep.createdBy': "Created by",
  'rep.createdAt': "Created",
  'rep.startedAt': "Started",
  'rep.completedAt': "Completed",
  'rep.connection': "Connection",
  'rep.statusRunning': "Running",
  'rep.statusPaused': "Paused",
  'rep.statusCompleted': "Completed",
  'rep.statusPending': "Pending",
  'rep.statusScheduled': "Scheduled",
  'rep.kpiTotal': "Recipients",
  'rep.kpiSent': "Sent",
  'rep.kpiDelivered': "Delivered",
  'rep.kpiRead': "Read",
  'rep.kpiFailed': "Failed",
  'rep.kpiPending': "Pending",
  'rep.kpiSkipped': "Skipped",
  'rep.ofSent': "of sent",
  'rep.ofDelivered': "of delivered",
  'rep.failures': "Why messages failed",
  'rep.noFailures': "No failures",
  'rep.bySession': "By connection",
  'rep.notAssigned': "Not assigned yet",
  'rep.messages': "Messages",
  'rep.search': "Search name or number",
  'rep.filterAll': "All",
  'rep.colContact': "Contact",
  'rep.colStatus': "Status",
  'rep.colDelivery': "Delivery",
  'rep.colSentAt': "Sent at",
  'rep.colDetails': "Details",
  'rep.msgSent': "Sent",
  'rep.msgFailed': "Failed",
  'rep.msgPending': "Pending",
  'rep.msgProcessing': "Sending",
  'rep.msgSkipped': "Skipped",
  'rep.receiptSent': "Sent to WhatsApp",
  'rep.receiptDelivered': "Delivered",
  'rep.receiptRead': "Read",
  'rep.receiptNone': "No confirmation yet",
  'rep.empty': "No messages match this filter",
  'rep.pageOf': "Page {page} of {pages}",
  'rep.showing': "{count} messages",
  'rep.errLoad': "Failed to load the report",
  'rep.okExport': "Report downloaded",
  'rep.errExport': "Failed to download the report",
  'rep.receiptsPending': "{count} sent messages have no confirmation yet",
  'rep.sysFailTitle': "{count} messages failed on our side, not because of the numbers",
  'rep.sysFailBody': "These numbers are fine and were never actually tried. Put them back in the queue and let the campaign finish.",
  'rep.sysFailAction': "Put back in the queue",
  'rep.sysFailOk': "{count} messages are back in the queue. Resume the campaign to finish sending.",
  'rep.sysFailErr': "Could not put the messages back in the queue",
  'nav.platform': "Platform",
  'sa.title': "Platform overview",
  'sa.subtitle': "How the whole service is doing right now",
  'sa.refresh': "Refresh",
  'sa.manage': "Manage companies",
  'sa.period14': "14 days",
  'sa.period30': "30 days",
  'sa.period90': "90 days",
  'sa.updated': "Updated {time}",
  'sa.errLoad': "Failed to load the platform overview",
  'sa.kpiCompanies': "Companies",
  'sa.kpiCompaniesSub': "{active} paying · {trial} on trial",
  'sa.kpiNew': "New this month",
  'sa.kpiNewSub': "{count} in the last {days} days",
  'sa.kpiMessages': "Messages this month",
  'sa.kpiMessagesSub': "{count} today",
  'sa.kpiCapacity': "Monthly capacity used",
  'sa.kpiCapacitySub': "{used} of {total} allowed",
  'sa.kpiConnections': "WhatsApp numbers",
  'sa.kpiConnectionsSub': "{connected} connected · {offline} offline",
  'sa.kpiCampaigns': "Campaigns running",
  'sa.kpiCampaignsSub': "{scheduled} scheduled",
  'sa.statusActive': "Paying",
  'sa.statusTrial': "On trial",
  'sa.statusExpired': "Expired",
  'sa.statusSuspended': "Suspended",
  'sa.attention': "Needs your attention",
  'sa.attentionEmpty': "Nothing needs attention right now",
  'sa.attSUSPENDED': "Account suspended",
  'sa.attTRIAL_ENDED': "Trial has ended",
  'sa.attTRIAL_ENDING': "Trial ends in {days} days",
  'sa.attTRIAL_ENDING_1': "Trial ends tomorrow",
  'sa.attSUBSCRIPTION_ENDED': "Subscription expired",
  'sa.attSUBSCRIPTION_ENDING': "Subscription ends in {days} days",
  'sa.attSUBSCRIPTION_ENDING_1': "Subscription ends tomorrow",
  'sa.attQUOTA_REACHED': "Monthly limit reached",
  'sa.attQUOTA_NEAR': "Used {pct}% of the monthly limit",
  'sa.attNO_CONNECTION': "No connected WhatsApp number",
  'sa.plans': "Companies per plan",
  'sa.planNoCompanies': "No companies",
  'sa.planCompanies': "{count} companies",
  'sa.planCompany': "1 company",
  'sa.planUnlimited': "No monthly limit",
  'sa.planLimit': "{count} messages/month",
  'sa.activity': "Daily activity",
  'sa.legendSent': "Sent",
  'sa.legendFailed': "Failed",
  'sa.noActivity': "No messages in this period",
  'sa.newCompanies': "{count} new companies",
  'sa.companies': "Companies by usage",
  'sa.colCompany': "Company",
  'sa.colPlan': "Plan",
  'sa.colUsage': "Monthly usage",
  'sa.colActivity': "Sent in {days} days",
  'sa.colConnections': "Numbers",
  'sa.colLastSend': "Last send",
  'sa.never': "Never",
  'sa.unlimited': "Unlimited",
  'sa.billedNote': "Counted against the plan: {count}",
  'sa.noCompanies': "No companies yet",
  'sa.totals': "{users} users · {contacts} contacts across the platform",
  'dash.noNumbers': "No WhatsApp number connected yet",
  'dash.connectNumber': "Connect a number",
  'dash.openPlatform': "Open the platform overview",
  'company.messagesDay': "Messages today",
  'sub.leftToday': "Only {left} message(s) left today.",
  'sub.usageToday': "{used} / {limit} today",
  'landing.report.eyebrow': "Campaign reports",
  'landing.report.title': "See what every campaign actually did",
  'landing.report.text': "After each campaign you get a report showing how many messages arrived and were read, who replied, and why any message did not arrive — downloadable as Excel.",
  'landing.report.point1': "Delivery, read and reply rates per campaign",
  'landing.report.point2': "A clear reason for every message that failed",
  'landing.report.point3': "The list of everyone who engaged, ready to follow up",
  'landing.report.campaign': "October offers — report",
  'landing.report.progress': "Completed",
  'landing.report.deliveryRate': "Delivery rate",
  'landing.report.readRate': "Read rate",
  'landing.report.replyRate': "Reply rate",
  'landing.report.failures': "Why messages did not arrive",
  'landing.report.fail1': "Number is not on WhatsApp",
  'landing.report.fail2': "Media file could not be downloaded",
  'landing.report.repliers': "Who replied",
  'landing.report.reply1': "How much is it?",
  'landing.report.reply2': "I would like to see the offer",
  'landing.report.reply3': "When does it arrive?",
  'landing.report.minutes': "{count} min ago",
  'landing.report.export': "Download Excel",
  'landing.contact.whatsapp': "Chat with us on WhatsApp",
  'landing.contact.prefill': "Hello, I would like to know more about the WhatsApp marketing platform.",
  'landing.contact.footer': "Questions and support",
  'ob.title': "Start here",
  'ob.subtitle': "Five steps between you and your first campaign",
  'ob.progress': "{done} of {total} done",
  'ob.next': "Next step",
  'ob.go': "Start this step",
  'ob.done': "Done",
  'ob.hide': "Hide the guide",
  'ob.show': "Getting started",
  'ob.connection.title': "Connect a WhatsApp number",
  'ob.connection.text': "Scan a QR code once and the number is ready to send and receive.",
  'ob.connection.action': "Go to connections",
  'ob.connection.doneText': "Number connected",
  'ob.contacts.title': "Add your contacts",
  'ob.contacts.text': "Import an Excel or CSV file, or add numbers by hand, and group them into categories.",
  'ob.contacts.action': "Go to contacts",
  'ob.contacts.doneText': "{count} contacts",
  'ob.campaign.title': "Create your first campaign",
  'ob.campaign.text': "Pick the category, write the message, and attach an image or file if you want.",
  'ob.campaign.action': "Go to campaigns",
  'ob.campaign.doneText': "{count} campaigns",
  'ob.send.title': "Launch it and watch it go out",
  'ob.send.text': "Start the campaign and follow the numbers as they move: sent, delivered, read.",
  'ob.send.action': "Launch your campaign",
  'ob.send.doneText': "{count} messages sent",
  'ob.inbox.title': "Answer your first reply",
  'ob.inbox.text': "Replies land in the inbox — open it and answer straight from the platform.",
  'ob.inbox.action': "Open the inbox",
  'ob.inbox.doneText': "{count} messages received",
  'ob.welcome.title': "Welcome 👋",
  'ob.welcome.text': "Your account is ready. Five short steps and you will have sent your first campaign and seen the result.",
  'ob.welcome.start': "Start the first step",
  'ob.welcome.later': "Later",
  'ob.banner.step': "Step {index} of {total}",
  'ob.banner.finished': "Getting started complete 🎉",
  'ob.banner.finishedText': "Your account is fully set up. You can review your campaign results from the dashboard anytime.",
  'login.phone': "WhatsApp number",
  'login.email': "Email",
  'login.useEmail': "Use email instead",
  'login.usePhone': "Use your WhatsApp number instead",
  'login.blurb': "Manage your WhatsApp contacts and campaigns from one place.",
  'login.noAccount': "No account yet?",
  'login.contactUs': "Talk to us on WhatsApp",
  'login.contactPrefill': "Hello, I would like to open an account on the WhatsApp marketing platform.",
  'set.aiTitle': "AI integrations",
  'set.visibilityTitle': "What companies see on this page",
  'set.visibilityHelp': "Choose which integrations your customers can see. The ones left off stay visible to you alone, and can be turned on anytime.",
  'set.visibilityAi': "Show the AI integrations (OpenAI and Groq)",
  'set.visibilityChatwoot': "Show the Chatwoot integration",
  'set.visibilityPerfex': "Show the Perfex CRM integration",
  'set.visibilitySaved': "Visibility settings saved",
  'set.errSave': "Failed to save the settings",
  'set.aiHelp': "Configure the API keys to use artificial intelligence in campaigns",
  'set.chatwootTitle': "Chatwoot integration",
  'set.perfexTitle': "Perfex CRM integration",
  'set.perfexHelp': "Configure the Perfex CRM integration to sync customers and leads",
  'set.configured': "Configured",
  'set.notConfigured': "Not configured",
  'dash.warmingUp': "Warming up — day {day}, {limit} messages allowed",
  'aud.title': "Campaign audience",
  'aud.subtitle': "Who will receive this campaign, and why the rest will not",
  'aud.refresh': "Recalculate",
  'aud.total': "Whole list",
  'aud.eligible': "Eligible to receive",
  'aud.validWhatsApp': "On WhatsApp",
  'aud.unknownWhatsApp': "Not checked yet",
  'aud.excludedTitle': "Excluded",
  'aud.engagementTitle': "Engagement",
  'aud.rulesTitle': "Rules applied",
  'aud.ruleCooldown': "{hours} hours between campaigns to the same customer",
  'aud.ruleFrequency': "At most {count} campaigns every {days} days",
  'aud.ruleConsent': "Only contacts with recorded consent",
  'aud.noExclusions': "Nobody excluded — the whole list is eligible",
  'aud.showList': "Show the list",
  'aud.hideList': "Hide the list",
  'aud.colContact': "Contact",
  'aud.colReason': "Why excluded",
  'aud.emptyList': "No contacts with this reason",
  'aud.errLoad': "Failed to load the audience analysis",
  'aud.at': "Calculated {time}",
  'ex.OPTED_OUT': "Unsubscribed",
  'ex.SUPPRESSED': "On the suppression list",
  'ex.INVALID_NUMBER': "Number is not on WhatsApp",
  'ex.TEMP_FAILURE': "Temporary failure — will be retried",
  'ex.NO_CONSENT': "No recorded consent",
  'ex.COOLDOWN': "Contacted recently",
  'ex.FREQUENCY_CAP': "Over the campaign limit",
  'eng.ENGAGED': "Engaged (replied recently)",
  'eng.ACTIVE': "Active (messaged recently)",
  'eng.INACTIVE': "Dormant",
  'eng.NEW': "New",
  'hlt.title': "Campaign health",
  'hlt.sent': "Sent",
  'hlt.delivered': "Delivered",
  'hlt.read': "Read",
  'hlt.failed': "Failed",
  'hlt.replied': "Replied",
  'hlt.optedOut': "Unsubscribed",
  'hlt.stoppedTitle': "This campaign is stopped",
  'hlt.stopOPT_OUT_RATE': "Stopped because {optedOut} of {sent} asked to stop ({rate}%), above the {limit}% limit.",
  'hlt.stopFAILURE_RATE': "Stopped because {failed} of {processed} failed ({rate}%), above the {limit}% limit.",
  'hlt.stopDELIVERY_RATE': "Stopped because delivery fell to {rate}%, below the {limit}% minimum.",
  'hlt.stopMANUAL': "Your team stopped it.",
  'hlt.stopButton': "Stop the campaign now",
  'hlt.stopConfirm': "Stop this campaign? You can resume it after reviewing.",
  'hlt.stopped': "Campaign stopped",
  'hlt.errStop': "Failed to stop the campaign",
  'win.title': "Sending hours",
  'win.help': "Choose the periods of the day your campaigns go out in. You can add more than one — mornings and late afternoons, for example — and nothing is sent outside them.",
  'win.period': "Period {number}",
  'win.from': "From",
  'win.to': "To",
  'win.add': "Add a period",
  'win.remove': "Remove",
  'win.save': "Save the hours",
  'win.saved': "Sending hours saved",
  'win.errSave': "Failed to save the hours",
  'win.errSame': "One period starts and ends at the same time",
  'win.timezone': "in {zone} time",
  'common.saving': "Saving…",
  'camp.ownSchedule': "Sending hours just for this campaign",
  'camp.ownScheduleHelp': "Left off, the campaign follows the company hours set in settings.",
  'conn.lastConnectedAs': "Last connected number:",
  'pc.title': "WhatsApp numbers across all companies",
  'pc.subtitle': "Every connection in one place — what is up, what dropped, and what was never scanned",
  'pc.connected': "Connected",
  'pc.waitingQr': "Waiting for the QR scan",
  'pc.offline': "Not connected",
  'pc.colNumber': "Number",
  'pc.colCompany': "Company",
  'pc.colStatus': "Status",
  'pc.colInbox': "Inbox",
  'pc.colToday': "Sent today",
  'pc.colLastSend': "Last send",
  'pc.noPhone': "Not linked yet",
  'pc.empty': "No connections on the platform",
  'pc.filterAll': "All",
  'pc.companySuspended': "Company suspended",
  'pc.never': "None",
  'pc.errLoad': "Failed to load the connections",
  'sa.schemaTitle': "The database is behind the code",
  'sa.schemaHelp': "Some tables or columns are missing, which makes certain screens answer with a 500. Restarting the server applies the update.",
};
